const trustSignals = [
  {
    title: 'Admin-reviewed profiles',
    text: 'Artist visibility, featured status, and portfolio links can be reviewed before public display.',
  },
  {
    title: 'Protected contact details',
    text: 'Email, phone, and social links stay off public listing cards and are shown only in profile context.',
  },
  {
    title: 'Media safety review',
    text: 'Profile images and performance videos can be checked and removed from the admin panel.',
  },
  {
    title: 'Private Message Board',
    text: 'Enquiries continue in PMB so artists and collaborators can keep serious work conversations organized.',
  },
];

const compactSignals = [
  'Admin review before public visibility',
  'Contact details protected from listing cards',
  'CAPTCHA and login checks for safer signups',
];

const LaunchTrustSignals = ({ compact = false, tone = 'orange' }) => {
  const toneClasses =
    tone === 'teal'
      ? 'border-teal-100 bg-teal-50 text-[#008C7A]'
      : 'border-orange-100 bg-orange-50 text-[#FF6F00]';

  if (compact) {
    return (
      <div className={`rounded-2xl border px-4 py-3 ${toneClasses}`}>
        <p className="text-xs font-bold uppercase tracking-[0.18em]">Safe launch promise</p>
        <ul className="mt-2 space-y-1 text-xs leading-5 text-gray-700">
          {compactSignals.map((signal) => (
            <li key={signal} className="flex gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-current" />
              <span>{signal}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <section className="rounded-[2rem] border border-orange-100 bg-white p-5 shadow-xl sm:p-7" data-testid="join-trust-signals">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#00BFA5]">Trust built in</p>
          <h2 className="mt-2 text-2xl font-bold text-gray-900 sm:text-3xl">
            Safer signups before public discovery.
          </h2>
        </div>
        <p className="max-w-xl text-sm leading-6 text-gray-600">
          Kala Manch is being prepared for public launch with profile review, media controls, and privacy-first
          contact visibility.
        </p>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {trustSignals.map((signal) => (
          <article key={signal.title} className="rounded-2xl bg-gradient-to-br from-orange-50 via-white to-purple-50 p-4 ring-1 ring-orange-100">
            <div className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-sm font-bold text-[#FF6F00] shadow-sm">
              OK
            </div>
            <h3 className="font-bold text-gray-900">{signal.title}</h3>
            <p className="mt-2 text-sm leading-6 text-gray-600">{signal.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default LaunchTrustSignals;
